export default __webpack_public_path__ + "static/media/user2.ddd14b39.jpg";